import app from 'app';
import Marionette from 'backbone.marionette';

export default Marionette.ItemView.extend({
  className: 'wt-route-not-found wt-editor-modal',

  ui: {
    btnBack: '.js-btnBack',
    btnMakeNewVideo: '.js-btnMakeNewVideo',
  },

  events: {
    'click @ui.btnBack': '_btnBack',
    'click @ui.btnMakeNewVideo': '_btnMakeNewVideo',
  },

  initialize: function () {
    this.template = app.compileTemplate.$('#route-not-found-tmpl');
  },

  _btnBack: function () {
    if (window.history && window.history.length > 1) {
      window.history.back();
    } else {
      app.navigate('/', { trigger: true });
    }
  },

  _btnMakeNewVideo: function () {
    app.navigate('/dashboard/home', { trigger: true });
  },
});
